import ImageComponent from "common/components/ImageComponent/ImageComponent";
import ImageFromStrapiMedia from "common/components/ImageFromStrapiMedia/ImageFromStrapiMedia";
import type { StrapiFile } from "types";

type Props = {
  image: StrapiFile;
};

function Image({ image }: Props) {
  return (
    <div className="flex relative w-40 h-30 lg:w-24 lg:h-20 shrink-0">
      <div className="rounded-lg overflow-hidden w-full shadow-md">
        <ImageComponent
          image={image ? ImageFromStrapiMedia(image)?.uri : undefined}
        />
      </div>
    </div>
  );
}

export default Image;
